import ValidatorResult from "../classes/validator.results";
export default class MinCountValidationRule {
    name = 'mincount';
    validate(validation, rule, value, object, manager) {
        //Message
        let tMessage = host.localizer?.tc('system.Validation.ArrayLengthMin', [validation.displayName, '', rule.props]);
        //Data
        if (value === undefined || value === null) {
            return new ValidatorResult(false, tMessage);
        }
        if (value.length < rule.props)
            return new ValidatorResult(false, tMessage);
        return new ValidatorResult(true);
    }
}
